import React, { Component } from "react";
import img from "../../../Assets/img/onlinecoursebg.png";

class TopImage extends Component {
  render() {
    return (
      <div>
        <img className="img-fluid" src={img} alt="..." />
      </div>
    );
  }
}
export default TopImage;
